<template>
  <div>
    <head-nav-bar title="订单日志" :fixed="true" />
    <div
      class="mt-header-nav order-log"
      style="margin-bottom:0;height:calc(100vh -46px)"
    >
      <van-search
        placeholder="请输入关键字"
        style="border-bottom:1px solid #f1f1f1;"
        v-model="keyword"
        @search="onSearch"
      />
      <div style="height:calc(100vh - 110px)">
        <DataList :api="getList" :params="params">
          <template v-slot:item="item">
            <div>
              <van-cell
                :value="item.CreationTime"
                :label="item.CodeName"
                :title="item.CreatorUserName"
              >
              </van-cell>
              <van-cell>
                <p
                  v-for="(cnt, index) in item.Content.split('\r\n')"
                  :key="index"
                >
                  {{ cnt }}
                </p>
              </van-cell>
            </div>
          </template>
        </DataList>
      </div>
      <!-- <van-cell-group>
        <van-cell
          v-for="(item, index) in orderLogList"
          :key="index"
          :value="item.OperationTime"
          :label="item.CodeName"
        >
          <div slot="title" class="title">
            <span> {{ item.GuestName }}</span>
            <span class="operater">{{ item.Operator }}</span>
          </div>
        </van-cell>
      </van-cell-group> -->
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import groupOrderApi from "../../api/group_order.js";
import { Search, CellGroup, Cell } from "vant";
export default {
  name: "GroupOrderLog",
  components: {
    DataList,
    [Search.name]: Search,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      params: {
        OrderId: this.$route.query.id,
        CompanyId: this.$route.query.companyId,
      },
      getList: groupOrderApi.GetOrderLogPageList,
      keyword: "",
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.companyId = this.$route.query.companyId;
  },
  methods: {
    onSearch() {
      this.params = {
        OrderId: this.orderId,
        CompanyId: this.companyId,
        KeyWord: this.keyword,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  display: inline-flex;
  width: 100%;
  & > span {
    flex: 1;
  }
}
.order-log {
  .van-cell__title {
    flex: 3;
  }
  .van-cell__value {
    font-size: 13px;
    flex: 2;
  }
  /deep/.list-item {
    .van-cell {
      padding: 3px 0.42667rem 6px;
    }
  }
}

.operater {
  /* margin-left: 10px; */
  color: #999;
}
</style>
